module.exports = __webpack_public_path__ + "img/customReport.51f31ea4.svg";